import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const isFutureDate = (date) => {
  return dayjs(date).isAfter(dayjs(), 'd');
};

export const DATETIMEFORMAT = 'YYYY-MM-DD HH:mm:ss';

export const ISODATETIMEFORMAT = 'YYYY-MM-DDTHH:mm:ss[Z]';

export const toUtcIsoString = (date = new Date()) =>
  dayjs(date).utc().format(ISODATETIMEFORMAT);
